"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const with_collapse_1 = require("../../molecules/with-collapse");
const MealHeader_1 = __importDefault(require("./MealHeader"));
const typography_1 = require("../../shared/typography");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = ({ meal }) => {
    return ((0, jsx_runtime_1.jsx)(Content, { children: (0, jsx_runtime_1.jsx)(with_collapse_1.WithCollapse, { header: (0, jsx_runtime_1.jsx)(MealHeader_1.default, { name: meal.name, shouldRenderMealPlanIcon: false }, void 0), body: (0, jsx_runtime_1.jsxs)(Wrapper, { "data-cy": "nutrition-meal-body", children: [meal.image && (0, jsx_runtime_1.jsx)("img", { alt: "thumbnail", src: meal.image.thumbnail }, void 0), (0, jsx_runtime_1.jsxs)(typography_1.H4, { children: [" ", meal.description] }, void 0)] }, void 0) }, void 0) }, void 0));
};
const Content = styled_components_1.default.div `
  & > div > div:first-of-type {
    padding: ${({ theme }) => theme.spacings.m};
  }
`;
const Wrapper = styled_components_1.default.div `
  width: 100%;
  word-wrap: break-word;
  display: flex;

  & > h4 {
    font-weight: 400;
    margin-bottom: 0;
  }

  img {
    width: 216px;
    height: 143px;
    object-fit: cover;
    margin-right: ${({ theme }) => theme.spacings.m};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    img {
      width: 99px;
      height: 66px;
    }
  }
`;
//# sourceMappingURL=CollapseMealHandpalm.js.map